import moment from 'moment';

function ComDetails(data) {
    this.entityData = data.entityData;
    this.email = this.createEmail(data);
    this.webhook = this.createWebhook(data);
    this.sms = this.createSms(data);
}

ComDetails.prototype = Object.assign(ComDetails.prototype, {
    createEmail(tableData) {
        return (
            tableData &&
            tableData.profileData &&
            tableData.profileData.EMAIL &&
            tableData.profileData.EMAIL.map(row => this.createRow(row))
        );
    },
    createWebhook(tableData) {
        return (
            tableData &&
            tableData.profileData &&
            tableData.profileData.WEBHOOK &&
            tableData.profileData.WEBHOOK.map(row => this.createRow(row))
        );
    },
    createSms(tableData) {
        return (
            tableData &&
            tableData.profileData &&
            tableData.profileData.SMS &&
            tableData.profileData.SMS.map(row => this.createRow(row))
        );
    },
    createRow(row) {
        const {
            data,
            noOfMerchants,
            linkedEntities,
            createdOn,
            updatedOn,
            createdBy,
            updatedBy,
        } = row;
        return {
            noOfMerchants: noOfMerchants || '-',
            linkedEntities: linkedEntities || '-',
            createdOn: this.formatData(createdOn) || '-',
            updatedOn: this.formatData(updatedOn) || '-',
            createdBy,
            updatedBy,
            type: (data && data.type) || '-',
            eventsListView: (data && this.formatEvents(data.eventsList)) || '-',
            identifier: (data && data.identifier) || '-',
            status: (data && this.formatStatus(data.status)) || '-',
            eventsList: data.eventsList,
            comments: data.comments,
            version: data.version
        };
    },
    formatEvents(eventsList) {
        if (eventsList && eventsList.length) {
            return eventsList.join(', ');
        }
        return '-';
    },

    formatStatus(status) {
        if (status) {
            return 'Active';
        }
        return 'Inactive';
    },
    formatData(date) {
        return moment(date).format('DD/MM/YYYY');
    },
});

export default ComDetails;
